import { extend } from 'vee-validate';

extend('password', {
  validate: (value) => {
    return {
      required: true,
      // Least 8 characters, include alphabets and numeric only
      valid: /^[a-zA-Z0-9]{8,}$/.test(value),
    };
  },
  computesRequired: true,
});
